<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 5.4c-.612 0-3.492.459-3.591 3.492a4.049 4.049 0 0 0 3.06-3.159c.477 1.035 1.764 2.52 3.987 2.34A3.573 3.573 0 0 0 9 5.4Zm-2.25 4.95a.675.675 0 1 0 0-1.35.675.675 0 0 0 0 1.35Zm4.5 0a.675.675 0 1 0 0-1.35.675.675 0 0 0 0 1.35Z"/>
    <path d="M14.4 9c0-2.979-2.421-5.4-5.4-5.4A5.404 5.404 0 0 0 3.6 9c-.495 0-.9.405-.9.9v1.8c0 .495.405.9.9.9h.9V9c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v4.5H8.1v.9h5.4c.495 0 .9-.405.9-.9v-.9c.495 0 .9-.405.9-.9V9.9c0-.495-.405-.9-.9-.9Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
